<template>
  <v-row>
    <v-col cols="12">
      <v-row
        justify="center"
        align="center"
        style="border: dashed grey 1px; height: 150px"
        v-cloak
        @drop.prevent="addFile"
        @dragover.prevent
        no-gutters
      >
        <v-col md="auto">
          Drag images here
        </v-col>
        <v-col md="auto">
          <span class="grey--text mx-2">or</span>
        </v-col>
        <v-col md="auto">
          <v-btn
            @click="$refs.fileUpload.click()"
            outlined
            rounded
            color="primary"
          >
            Browse
          </v-btn>
          <input
            ref="fileUpload"
            type="file"
            @change="previewImage"
            accept="image/*"
            multiple
            style="display:none"
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    storagePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'getStorageFileUploadPercentage',
      'getStorageImagesByPath',
    ])
  },
  data() {
    return {
      imageData: null,
      files: []
    }
  },
  methods: {
    ...mapActions([ 'doStorageUpload' ]),
    getFullPath(file) {
      const { name } = file

      return `${this.storagePath}${name}`
    },
    kb(val) {
      return Math.floor(val/1024);
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if(!droppedFiles) return;

      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      this.onUpload()
    },
    clearInput() {
      const input = this.$refs.fileUpload;
      input.type = 'text';
      input.type = 'file';
    },
    previewImage(event) {
      const fileList = get(event, 'target.files', {})

      this.files = Object.values(fileList)

      this.onUpload()
      this.clearInput()
    },
    onUpload() {
      this.files.forEach(file => {
        const payload = {
          storagePath: this.storagePath,
          file,
          initUrl: URL.createObjectURL(file)
        }

        this.doStorageUpload(payload)
      })

      this.files = []
    }
  }
}
</script>
